import React from 'react'
import { Box, Button, ButtonGroup } from '@mui/material'
import sampleCourseCover from '../../../../Assets/img/sample-course-cover-pic.png'

function RecommCourses() {

    const sampleCourses = [
        {key:1, coverPic: sampleCourseCover, title: {type: 'Post Graduate Certificate', from: 'in Product Management from Duke CE'}, startDate: 'July 24 2024', duration: '6 months' },
        // {key:2, coverPic: sampleCourseCover, title: {type: 'AWS Certification', from: 'in AWS Technical Essentials from Amazon Learning'}, startDate: 'Aug 24 2024', duration: '3 months' }
    ] // fetch the most suitable courses based on user's profession

  return (
    <Box className='sidefeed-box recomm-courses-box my-2'> 
    <div className="sidefeed-titles mb-2">
        Recommended Courses
    </div>
    {sampleCourses.map((course) => {
        return (
        <div className="course-container">
        <div className="course-cover-pic">
            <img src={course.coverPic} alt={course.title} />
        </div>
        <div className="course-details">
            <div className='course-title mb-2'>
                <span className='course-type'>{course.title.type}</span><br />
                <span>{course.title.from}</span>
            </div>

            <div className='d-flex mt-1 mb-3 gap-3'>
                <div className="d-flex flex-column">
                    <span className='fw-semibold'>Start Date</span>
                    <span>{course.startDate}</span>
                </div>
                <div className="d-flex flex-column">
                    <span className='fw-semibold'>Duration</span>
                    <span>{course.duration}</span>
                </div>
            </div>

            <div className="course-action-box">
                <ButtonGroup variant='text' sx={{color: '#0044C6'}}>
                    <Button>SYLLABUS</Button>
                    <Button>APPLY</Button>
                </ButtonGroup>
            </div>
        </div>
    </div>
    )}
    )}
    </Box>
  )
}

export default RecommCourses